import React from "react";
import "./QualityCheckForm.css";
import Button from "../Button/Button";
import { ChevronDown, ChevronUp } from "lucide-react";

const QualityCheckForm = ({
  setExpandedSectionIndex,
  expandedSectionIndex,
  setExpandedParamKey,
  expandedParamKey,
  setVisible,
  visible,
  setActiveTab2,
  formData,
  setFormData,
}) => {
  const handleClose = () => setVisible(false);

  const toggleSectionHeader = (sectionIndex) => {
    setExpandedSectionIndex(
      expandedSectionIndex === sectionIndex ? null : sectionIndex
    );
    setExpandedParamKey(null);
  };

  const formatReportName = (reportType) => {
    return reportType
      .split("_")
      .map((word) =>
        ["mis", "ptp", "apr"].includes(word.toLowerCase())
          ? word.toUpperCase()
          : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(" ");
  };

  const toggleParameter = (sectionIndex, paramIndex) => {
    const currentKey = `${sectionIndex}-${paramIndex}`;
    setExpandedParamKey(expandedParamKey === currentKey ? null : currentKey);
  };

 const handleInputChange = (sectionIndex, paramIndex, field, value) => {
  setFormData((prev) => {
    if (!Array.isArray(prev)) return prev;
    const updated = [...prev];
    const section = { ...updated[sectionIndex] };
    const parameters = [...section.parameters];
    const param = { ...parameters[paramIndex] };

    if (field === "response") {
      param.answer = value;
    } else if (field === "comment") {
      // 🔹 always set user_comment explicitly
      param.user_comment = value;
    }

    parameters[paramIndex] = param;
    section.parameters = parameters;
    updated[sectionIndex] = section;

    return updated;
  });
};


  const handleProceedSubmit = () => {
    setActiveTab2("AI Summary");
    setFormData(formData)

  };

  const handleSubmit = (sectionIndex, paramIndex) => {
    setFormData((prev) => {
      if (!Array.isArray(prev)) return prev;
      const updated = [...prev];
      const section = { ...updated[sectionIndex] };
      const parameters = [...section.parameters];
      const param = { ...parameters[paramIndex] };
      param.completed = true;
      parameters[paramIndex] = param;
      section.parameters = parameters;
      updated[sectionIndex] = section;
      return updated;
    });

    // Move to next parameter
    const nextParamIndex = paramIndex + 1;
    if (nextParamIndex < formData[sectionIndex].parameters.length) {
      setExpandedParamKey(`${sectionIndex}-${nextParamIndex}`);
    } else {
      setExpandedParamKey(null);
    }
  };

  return (
    <>
      <div className="quality-check-form">
        <div
          className="quality-banner"
          style={{
            display: visible ? "flex" : "none",
            justifyContent: "space-between",
          }}
        >
          <div>
            To maintain the quality of our system we need to check & confirm
            these all parameters are submitted accurately and correctly!
          </div>
          <button
            type="button"
            className="close-btn"
            onClick={handleClose}
            style={{ color: "white", width: 20, fontSize: 13 }}
          >
            &times;
          </button>
        </div>

        {/* 🔹 Render sections safely */}
        {Array.isArray(formData) &&
          formData.map((section, sectionIndex) => {
            const sectionActive = expandedSectionIndex === sectionIndex;

            return (
              <div key={sectionIndex} className="quality-check-form-model-section">
                {/* Section Header */}
                <div
                  className="section-header"
                  onClick={() => toggleSectionHeader(sectionIndex)}
                >
                  <h6 className="section-title">{section.title}</h6>
                  <div className="dropdown-icon">
                    {sectionActive ? (
                      <ChevronUp size={16} />
                    ) : (
                      <ChevronDown size={16} />
                    )}
                  </div>
                </div>

                {/* Parameters */}
                {sectionActive && (
                  <div className="section-parameters">
                    {section.parameters.map((param, paramIndex) => {
                      const currentKey = `${sectionIndex}-${paramIndex}`;
                      const isActive = expandedParamKey === currentKey;

                      return (
                        <div
                          key={paramIndex}
                          className={`param-block ${
                            isActive ? "active-section" : ""
                          }`}
                        >
                          <div className="section-header">
                            <p
                              onClick={() =>
                                toggleParameter(sectionIndex, paramIndex)
                              }
                            >
                              Q.{paramIndex + 1} {param.title}
                            </p>

                            <div className="button-group">
                              <button
                                style={{ minWidth: "40px" }}
                                className={
                                  param.answer === "yes"
                                    ? "button-active"
                                    : "button-deactive"
                                }
                                onClick={() =>
                                  handleInputChange(
                                    sectionIndex,
                                    paramIndex,
                                    "response",
                                    "yes"
                                  )
                                }
                              >
                                Yes
                              </button>

                              <button
                                style={{ minWidth: "40px" }}
                                className={
                                  param.answer === "no"
                                    ? "button-active"
                                    : "button-deactive"
                                }
                                onClick={() =>
                                  handleInputChange(
                                    sectionIndex,
                                    paramIndex,
                                    "response",
                                    "no"
                                  )
                                }
                              >
                                No
                              </button>

                              <button
                                style={{ minWidth: "60px" }}
                                className={
                                  param.answer === "not sure"
                                    ? "button-active"
                                    : "button-deactive"
                                }
                                onClick={() =>
                                  handleInputChange(
                                    sectionIndex,
                                    paramIndex,
                                    "response",
                                    "not sure"
                                  )
                                }
                              >
                                Not Sure
                              </button>
                            </div>
                          </div>

                          {isActive && (
                            <div className="section-content">
                              <div className="section-content-child">
                                {/* Keywords Table */}
                                <table className="sub-table-container">
                                  <thead
                                    className="table-head"
                                    style={{
                                      position: "sticky",
                                      top: "0",
                                      zIndex: "1",
                                    }}
                                  >
                                    <tr>
                                      <th className="table-style">Sr.No</th>
                                      <th className="table-style">Keyword</th>
                                      <th className="table-style">Value</th>
                                    </tr>
                                  </thead>
                                  <tbody className="table-body">
                                    {param.keywords_data &&
                                      Object.entries(
                                        param.keywords_data
                                      ).map(([key, value], idx) => (
                                        <tr key={key}>
                                          <th className="table-style">
                                            {idx + 1}
                                          </th>
                                          <td className="table-style">
                                            {formatReportName(key)}
                                          </td>
                                          <td className="table-style">
                                            {value}
                                          </td>
                                        </tr>
                                      ))}
                                  </tbody>
                                </table>

                                {/* Comment Box */}
                                <textarea
                                  placeholder="Add Comment"
                                  className="comment-box"
                                  value={param.user_comment ?? ""}  // safer than ||
                                  onChange={(e) =>
                                    handleInputChange(
                                      sectionIndex,
                                      paramIndex,
                                      "comment",
                                      e.target.value
                                    )
                                  }
                                />


                                <Button
                                  variant="primary"
                                  size="sm"
                                  onClick={() =>
                                    handleSubmit(sectionIndex, paramIndex)
                                  }
                                >
                                  Save & Next
                                </Button>
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
      </div>

      <div style={{ padding: 10, position: "sticky", bottom: 0, background: "#F8F8F8", borderTop: "1px solid #e5e7eb", zIndex: 10 }}>
        <Button variant="primary"  size="md" onClick={handleProceedSubmit}>
          Proceed &raquo;
        </Button>
      </div>
    </>
  );
};

export default QualityCheckForm;
